import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { PhotoGridService } from 'app/services/photo-grid.service';
import { FirebaseService } from 'app/services/firebase.service';

@Component({
  selector: 'image-progress',
  styleUrls: ['./designing.component.scss', './progress.component.scss'],
  templateUrl: './progress.component.html',
})
export class ImageProgressComponent implements OnChanges {
  @Input() dedupedPhotoCount;
  @Input() totalPhotos;
  @Input() processedPhotoCount;
  @Input() isPreprocessing;
  @Input() isDeduping;
  @Input() projectId;
  @Input()isWarmingUpModel;
  @Output() next = new EventEmitter();
  @Output() prev = new EventEmitter();

  t0;
  t1;

  dedupProgress;
  preprocessProgress;
  dedupInitiated = false;
  waitingTimer = 60000;

  constructor(
    public translate: TranslateService,
    public photoGridService: PhotoGridService,
    public firebaseService: FirebaseService,
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    this.preprocessProgress = this.processedPhotoCount * 100 / this.totalPhotos;
    this.dedupProgress = this.dedupedPhotoCount * 100 / this.totalPhotos;
    if (this.dedupedPhotoCount > 0 && !this.dedupInitiated) {
      this.t0 = performance.now();
      this.dedupInitiated = true;
    }
    if (this.dedupedPhotoCount === this.totalPhotos - 1) {
      this.t1 = performance.now();
      this.firebaseService.logEvent('design_request_processing_end', {
        project_id: this.projectId,
        processed: this.processedPhotoCount,
        target: this.totalPhotos,
        time: (this.t1 - this.t0),
        type: 'deduplication'
      });
    }
  }

  cancelDeduplication() {
    this.t1 = performance.now();
    this.firebaseService.logEvent('design_request_photo_processing_cancel', {
      project_id: this.projectId,
      processed: this.processedPhotoCount,
      target: this.totalPhotos,
      time: (this.t1 - this.t0),
      type: 'deduplication'
    });
    this.photoGridService.cancelDedup();
  }

  submit() {
    this.next.emit();
  }
}
